exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-a7c1e05e]{margin:2em 0 3em;text-align:center;font-size:2em;font-weight:800;font-family:Open Sans,sans-serif;text-transform:uppercase;color:#0d64aa}.loader i[data-v-a7c1e05e]{margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a7c1e05e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Elements/Loading.vue
// module id = zokE
// module chunks = 0